import { GetterTree, Getter } from 'vuex';
import { RootState } from '@/store/types/root.state';
import { CircularPianoState } from '@/store/types/circular-piano.state';

export const getters: GetterTree<CircularPianoState, RootState> = {
    
};